var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStopCircleFill(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "#FFEBEB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1086_3173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 56C24.954 56 16 47.046 16 36C16 24.954 24.954 16 36 16C47.046 16 56 24.954 56 36C56 47.046 47.046 56 36 56ZM36 52C40.2435 52 44.3131 50.3143 47.3137 47.3137C50.3143 44.3131 52 40.2435 52 36C52 31.7565 50.3143 27.6869 47.3137 24.6863C44.3131 21.6857 40.2435 20 36 20C31.7565 20 27.6869 21.6857 24.6863 24.6863C21.6857 27.6869 20 31.7565 20 36C20 40.2435 21.6857 44.3131 24.6863 47.3137C27.6869 50.3143 31.7565 52 36 52ZM30 30H42V42H30V30Z",
    fill: "#FF4D4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1086_3173"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopCircleFill);
export default __webpack_public_path__ + "static/media/stop-circle-fill.e301d7f9eece8ef0e10078cb11083f4a.svg";
export { ForwardRef as ReactComponent };